import { ISODateTime } from '../../commonv3/types/dates';
import { UserId } from '../../mainv2/types/user';
import { ImageRef } from '../../commonv3/types/image';

export type UserTutorialCompletionId = number;
export enum UserTutorialCompletionKey {
    KEY_FIRST_LOGIN = 'first_login',
    KEY_JOIN_SLACK = 'join_slack',
    KEY_COMPLETE_TUTORIAL_COURSE = 'complete_tutorial_course',
    KEY_RESERVE_COACHING = 'reserve_coaching',
    KEY_START_COURSE = 'start_course',
}

export type UserTutorialCompletionIndexView = {
    id: UserTutorialCompletionId;
    user_id: UserId;
    tutorial_key: UserTutorialCompletionKey;
    created_at: ISODateTime;
};

export type UserTutorialCompletiontText = {
    image: ImageRef;
    number: number;
    title: string;
    description: string;
    comment: string;
};

export const AllUserTutorialCompletionKeys = [
    UserTutorialCompletionKey.KEY_FIRST_LOGIN,
    UserTutorialCompletionKey.KEY_COMPLETE_TUTORIAL_COURSE,
    UserTutorialCompletionKey.KEY_JOIN_SLACK,
    UserTutorialCompletionKey.KEY_RESERVE_COACHING,
    UserTutorialCompletionKey.KEY_START_COURSE,
];
